module.exports = __webpack_public_path__ + "img/layer.33a695d3.svg";